import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'

type Props = {
  isViewingOwnItem: boolean
}

export const useShowStickyButtons = ({ isViewingOwnItem }: Props): boolean => {
  const breakpoints = useBreakpoint()

  const showStickyButtons = breakpoints.phones && !isViewingOwnItem

  return !!showStickyButtons
}
